import React from 'react';
import { RatingCircle } from './ui/RatingCircle';
import { Monitor, Gamepad, Smartphone } from 'lucide-react';
interface RatingCardProps {
  title: string;
  genre: string;
  score: number;
  criticScore: number;
  userScore: number;
  price: number;
  image: string;
  platforms?: string[];
  delay?: number;
}
export function RatingCard({
  title,
  genre,
  score,
  criticScore,
  userScore,
  price,
  image,
  platforms = ['PC', 'PS5', 'XSX'],
  delay = 0
}: RatingCardProps) {
  return <div className="group bg-pinnacle-card border border-pinnacle-border rounded-xl overflow-hidden hover:border-pinnacle-green/50 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_10px_30px_rgba(0,0,0,0.5)] animate-fade-in-up" style={{
    animationDelay: `${delay}ms`
  }} data-id="element-156">
      {/* Image Area */}
      <div className="relative h-48 overflow-hidden" data-id="element-157">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-158" />
        <div className="absolute inset-0 bg-gradient-to-t from-pinnacle-card to-transparent opacity-90" data-id="element-159"></div>
        <div className="absolute bottom-4 left-4 right-4 flex justify-between items-end" data-id="element-160">
          <div data-id="element-161">
            <span className="text-xs font-bold text-pinnacle-cyan uppercase tracking-wider bg-pinnacle-cyan/10 px-2 py-1 rounded mb-2 inline-block" data-id="element-162">
              {genre}
            </span>
            <h3 className="text-xl font-bold text-white leading-tight" data-id="element-163">
              {title}
            </h3>
          </div>
        </div>
      </div>

      {/* Content Area */}
      <div className="p-5" data-id="element-164">
        <div className="flex items-center justify-between mb-6" data-id="element-165">
          <div className="flex flex-col gap-1" data-id="element-166">
            <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-167">
              <span data-id="element-168">Critic</span>
              <div className="w-24 h-1.5 bg-gray-700 rounded-full overflow-hidden" data-id="element-169">
                <div className="h-full bg-blue-500 rounded-full" style={{
                width: `${criticScore}%`
              }} data-id="element-170"></div>
              </div>
              <span className="text-white font-bold" data-id="element-171">{criticScore}</span>
            </div>
            <div className="flex items-center gap-2 text-sm text-gray-400" data-id="element-172">
              <span data-id="element-173">User</span>
              <div className="w-24 h-1.5 bg-gray-700 rounded-full overflow-hidden" data-id="element-174">
                <div className="h-full bg-green-500 rounded-full" style={{
                width: `${userScore}%`
              }} data-id="element-175"></div>
              </div>
              <span className="text-white font-bold" data-id="element-176">{userScore}</span>
            </div>
          </div>

          <div className="flex flex-col items-center" data-id="element-177">
            <RatingCircle score={score} size={56} strokeWidth={4} data-id="element-178" />
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-pinnacle-border" data-id="element-179">
          <div className="flex gap-2 text-gray-500" data-id="element-180">
            {platforms.includes('PC') && <Monitor size={16} data-id="element-181" />}
            {(platforms.includes('PS5') || platforms.includes('XSX')) && <Gamepad size={16} data-id="element-182" />}
            {platforms.includes('Mobile') && <Smartphone size={16} data-id="element-183" />}
          </div>
          <div className="font-bold text-white" data-id="element-184">€{price.toFixed(2)}</div>
        </div>
      </div>
    </div>;
}